var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndividualsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8725 16.625H5.8725C4.71 16.625 4.12875 16.625 3.65125 16.7334C3.01539 16.8783 2.43562 17.163 1.97022 17.5587C1.50483 17.9545 1.17021 18.4475 1 18.988",
    stroke: "#243142",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 7.0625H16M6 10.7812H12.25M8.5 23C4.965 23 3.19625 23 2.09875 22.0661C1 21.1332 1 19.6298 1 16.625V8.125C1 5.12025 1 3.61681 2.09875 2.68394C3.19625 1.75 4.965 1.75 8.5 1.75H13.5C17.035 1.75 18.8037 1.75 19.9012 2.68394C21 3.61681 21 5.12025 21 8.125M13.5 23C17.035 23 18.8037 23 19.9012 22.0661C21 21.1332 21 19.6298 21 16.625V12.375",
    stroke: "#243142",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualsIcon);
export default __webpack_public_path__ + "static/media/IndividualsIcon.f3c9fb0e5ab808e11ce0523bc6b4e66a.svg";
export { ForwardRef as ReactComponent };